import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';

export const createSortableHeader = (
  columnTitle: any,
  column: any,
  divClass = 'd-flex align-items-center',
  style: React.CSSProperties = {}
) => {
  return (
    <div className={`${divClass}`} style={{ cursor: 'pointer', ...style }}>
      {columnTitle}
      {column.getIsSorted() === 'asc' ? (
        <FaSortUp className="ms-1" />
      ) : column.getIsSorted() === 'desc' ? (
        <FaSortDown className="ms-1" />
      ) : (
        <FaSort className="ms-1" />
      )}
    </div>
  );
};
